import React, { useState, useEffect } from "react";
import {
  Modal,
  TextInput,
  Button,
  Group,
  Stack,
  Select,
  Alert,
} from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";

const AddOperatingLevelTypeModal = ({
  opened,
  onClose,
  onSave,
  operatingLevelTypes,
}) => {
  const [name, setName] = useState("");
  const [parentOperatingType, setParentOperatingType] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (opened) {
      setName("");
      setParentOperatingType(null);
      setError("");
    }
  }, [opened]);

  const parentOptions = (operatingLevelTypes || [])
    .filter(type => !type.base_operation_type)
    .map(type => ({
      value: String(type.id ?? type.name),
      label: type.name,
    }));

  const handleSave = async () => {
    if (!name.trim()) {
      setError("Name is required");
      return;
    }

    if (!parentOperatingType) {
      setError("Parent operating type is required");
      return;
    }

    setLoading(true);
    setError("");

    try {
      await onSave({
        name: name.trim(),
        operation_type_parent_id: parentOperatingType,
      });
      onClose();
    } catch (err) {
      setError(err.message || "Failed to save operations type");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setName("");
    setParentOperatingType(null);
    setError("");
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title="Add Operations Type"
      size="md"
    >
      <Stack gap="md">
        {error && (
          <Alert
            icon={<IconAlertCircle size={16} />}
            color="red"
            variant="light"
          >
            {error}
          </Alert>
        )}

        <TextInput
          label="Name"
          placeholder="Enter operations type name"
          value={name}
          onChange={e => setName(e.target.value)}
          required
        />

        <Select
          label="Parent Operation Type"
          placeholder="Select parent operations type"
          data={parentOptions}
          value={parentOperatingType}
          onChange={setParentOperatingType}
          required
          searchable
        />

        <Group justify="flex-end" gap="sm">
          <Button variant="outline" onClick={handleClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            loading={loading}
            disabled={!name.trim()}
          >
            Add
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default AddOperatingLevelTypeModal;
